const seoPage = {
  subtitle: 'Puede definir su meta título y descripción SEO.',
}

export default seoPage
